import {
  authTokensUpdateOzonCookie,
  productsOzonLoadProducts,
  productsWbLoadProducts,
  productsWbClassifyCategoryBrand,
  productsMpCatalogSyncWb,
  productsMpCatalogSyncOzon,
  productsMpProductSeedLinks,
  productsMpProductAutoMatch,
  reviewsOzonJobApprove,
  reviewsOzonJobGenerate,
  reviewsOzonJobLoadNew,
  reviewsOzonJobLoadNewDaemon,
  reviewsOzonJobLoadViewedAwaiting,
  reviewsOzonJobLoadViewedDaily,
  reviewsOzonJobLoadOld,
  reviewsOzonJobReset,
  reviewsOzonJobSend,
  reviewsWbJobApprove,
  reviewsWbJobGenerate,
  reviewsWbJobLoadNew,
  reviewsWbJobLoadOld,
  reviewsWbJobReset,
  reviewsWbJobSend,
  reviewsYaJobApprove,
  reviewsYaJobGenerate,
  reviewsYaJobLoadNew,
  reviewsYaJobLoadOld,
  reviewsYaJobReset,
  reviewsYaJobSend,
  reviewsJobReevaluateAutoReplies,
  remnantsComputeNewStock,
  remnantsRemnantZeroingOut,
  remnantsOzonLoadReserved,
  remnantsOzonSendRemnants,
  remnantsOzonLoadWarehouseStocks,
  yaJobSendPrices,
  yaJobSendRemnants,
  yaJobLoadReserved,
  yaJobLoadSales,
  yaJobUpdateSk,
  sberJobSendPrices,
  sberJobSendRemnants,
  sberJobLoadReserved,
  aliJobSendPrices,
  aliJobSendRemnants,
  aliJobLoadReserved,
  aliJobUpdateProductCode,
  ozonJobLoadSales,
  ozonJobSendPrices,
  productQuestionsJobLoad,
  productQuestionsJobSend,
  fbsOrdersJobSyncHot,
  fbsOrdersJobDayClose,
  wbSlotsEnsure,
} from "queue";

export interface Task {
  name: string;
  description: string;
  schedule: string;
  jobName: string;
  jobData?: Record<string, any>;
}

export const tasks: Task[] = [
  // WB Reviews
  {
    name: "WB: Загрузка новых отзывов",
    description: "Загружает последние отзывы с Wildberries.",
    schedule: "Каждые 5 минут",
    jobName: reviewsWbJobLoadNew,
  },
  {
    name: "WB: Загрузка старых отзывов",
    description: "Загружает историю отзывов с Wildberries.",
    schedule: "Раз в день",
    jobName: reviewsWbJobLoadOld,
  },
  {
    name: "WB: Генерация ответов",
    description: "Генерирует тексты ответов для отзывов.",
    schedule: "По мере необходимости",
    jobName: reviewsWbJobGenerate,
  },
  {
    name: "WB: Отправка ответов",
    description: "Отправляет сгенерированные ответы на Wildberries.",
    schedule: "Каждые 2 минуты",
    jobName: reviewsWbJobSend,
  },
  {
    name: "WB: Апрув отзывов",
    description:
      "Аппрув (подтверждение) отправленных ответов на отзывы Wildberries.",
    schedule: "Каждые 10 минут",
    jobName: reviewsWbJobApprove,
  },
  {
    name: "WB: Сброс статуса",
    description:
      "Сбрасывает статус опубликованных ответов для повторной отправки.",
    schedule: "По мере необходимости",
    jobName: reviewsWbJobReset,
  },
  // Ozon Reviews
  {
    name: "Ozon: Новые отзывы (демон)",
    description:
      "NOT_VIEWED, ожидающие ответа. После полного прохода — пауза 10 мин и снова. Watchdog cron каждые 10 мин.",
    schedule: "Цепочка + cron ensure */10",
    jobName: reviewsOzonJobLoadNewDaemon,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Новые отзывы (один проход)",
    description:
      "Только NOT_VIEWED без постановки следующего демона (ручной запуск).",
    schedule: "Вручную",
    jobName: reviewsOzonJobLoadNew,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Просмотренные, ждут ответа",
    description: "VIEWED, awaiting_reply: true.",
    schedule: "Ежедневно 04:00 UTC",
    jobName: reviewsOzonJobLoadViewedAwaiting,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Остальные просмотренные",
    description: "VIEWED без awaiting_reply (синхронизация раз в сутки).",
    schedule: "Ежедневно 03:30 UTC",
    jobName: reviewsOzonJobLoadViewedDaily,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Загрузка старых отзывов",
    description: "Загружает историю отзывов с Ozon.",
    schedule: "Раз в день",
    jobName: reviewsOzonJobLoadOld,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Генерация ответов",
    description: "Генерирует тексты ответов для отзывов.",
    schedule: "По мере необходимости",
    jobName: reviewsOzonJobGenerate,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Отправка ответов",
    description:
      "APPROVED/RESET → Ozon. После approve — сразу; пакет 15 с rate limit; cron */2 — страховка.",
    schedule: "По событию + cron */2",
    jobName: reviewsOzonJobSend,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Апрув отзывов",
    description: "Аппрув (подтверждение) отправленных ответов на отзывы Ozon.",
    schedule: "Каждые 10 минут",
    jobName: reviewsOzonJobApprove,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Сброс статуса",
    description:
      "Сбрасывает статус опубликованных ответов для повторной отправки.",
    schedule: "По мере необходимости",
    jobName: reviewsOzonJobReset,
    jobData: { marketplace: "ozon" },
  },
  // Yandex Market Reviews
  {
    name: "YA: Загрузка новых отзывов",
    description:
      "Загружает отзывы Яндекс Маркета, на которые нужно ответить (NEED_REACTION).",
    schedule: "Каждые 30 минут",
    jobName: reviewsYaJobLoadNew,
    jobData: { account: "fby" },
  },
  {
    name: "YA: Загрузка старых отзывов",
    description: "Синхронизирует все отзывы Яндекс Маркета (ALL).",
    schedule: "Раз в день",
    jobName: reviewsYaJobLoadOld,
    jobData: { account: "fby" },
  },
  {
    name: "YA: Генерация ответов",
    description: "Генерирует тексты ответов для отзывов Яндекс Маркета.",
    schedule: "По мере необходимости",
    jobName: reviewsYaJobGenerate,
  },
  {
    name: "YA: Отправка ответов",
    description: "Отправляет сгенерированные ответы на Яндекс Маркет.",
    schedule: "Каждые 2 минуты",
    jobName: reviewsYaJobSend,
    jobData: { account: "fby" },
  },
  {
    name: "YA: Апрув отзывов",
    description:
      "Аппрув (подтверждение) отправленных ответов на отзывы Яндекс Маркета.",
    schedule: "По мере необходимости",
    jobName: reviewsYaJobApprove,
  },
  {
    name: "YA: Сброс статуса",
    description:
      "Сбрасывает статус опубликованных ответов для повторной отправки.",
    schedule: "По мере необходимости",
    jobName: reviewsYaJobReset,
  },
  {
    name: "Переоценить автоответы",
    description:
      "Переоценка выбранных шаблонов у неотправленных сгенерированных ответов. LLM вызывается только если найден существенно лучший шаблон.",
    schedule: "По кнопке",
    jobName: reviewsJobReevaluateAutoReplies,
  },
  // Products
  {
    name: "WB: Загрузка товаров",
    description: "Обновляет список товаров с Wildberries.",
    schedule: "Раз в день",
    jobName: productsWbLoadProducts,
  },
  {
    name: "WB: Классификация категории и бренда (LLM)",
    description:
      "Разовая задача: подтягивает карточки WB, сопоставляет category и brand через Yandex GPT. Пропускает артикулы с заполненными полями или уже проверенные LLM.",
    schedule: "Разово",
    jobName: productsWbClassifyCategoryBrand,
  },
  {
    name: "Ozon: Загрузка товаров",
    description: "Обновляет список товаров с Ozon.",
    schedule: "Раз в день",
    jobName: productsOzonLoadProducts,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "МП: Sync каталог WB → mp_products",
    description:
      "Тянет карточки WB в mp_products (без создания Goods, без затирания связей).",
    schedule: "По запросу / UI",
    jobName: productsMpCatalogSyncWb,
  },
  {
    name: "МП: Sync каталог Ozon → mp_products",
    description:
      "Тянет карточки Ozon в mp_products (без создания Goods, без затирания связей).",
    schedule: "По запросу / UI",
    jobName: productsMpCatalogSyncOzon,
  },
  {
    name: "МП: Seed связей из alias/barcode",
    description:
      "Fill-only: создаёт article на mp_products по совпадению alias/barcode. Существующие связи не трогает.",
    schedule: "По запросу / UI",
    jobName: productsMpProductSeedLinks,
  },
  {
    name: "МП: Auto-match (normalizeArticleKey)",
    description:
      "Fill-only fuzzy exact по normalizeArticleKey для оставшихся без связи.",
    schedule: "По запросу / UI",
    jobName: productsMpProductAutoMatch,
  },
  {
    name: "Ozon: Обновить cookie из браузера",
    description: "Асинхронное обновление Ozon cookie через auth_tokens очередь.",
    schedule: "5:28, 9:28, 13:28, 17:28 UTC",
    jobName: authTokensUpdateOzonCookie,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "FBS заказы: sync 48ч",
    description:
      "Отдельная очередь fbs_orders (не remnants): upsert заказов WB+Ozon за последние 48ч включая отмены.",
    schedule: "Каждые 10 минут",
    jobName: fbsOrdersJobSyncHot,
    jobData: {},
  },
  {
    name: "FBS заказы: day-close",
    description:
      "Перечитывает вчерашний московский день и чистит строки старше 90 дней.",
    schedule: "01:15 Europe/Moscow",
    jobName: fbsOrdersJobDayClose,
    jobData: {},
  },
  // Stock management
  {
    name: "Расчёт целевых остатков (new_stock)",
    description:
      "Пересчитывает new_stock по remnant и share_in_* для всех МП, затем ставит need_update_stock при расхождении с last_stock.",
    schedule: "Каждую минуту",
    jobName: remnantsComputeNewStock,
    jobData: {},
  },
  {
    name: "Повторная очередь остатков (YA/Sber/Ali)",
    description:
      "Для Яндекс, Сбер и Ali: last_stock=-1 у синхронизированных товаров, чтобы updateRemnantsForSend снова поставил need_update_stock. Для WB/Ozon при включённой отправке — no-op.",
    schedule: "Каждые 10 минут",
    jobName: remnantsRemnantZeroingOut,
    jobData: {},
  },
  // Stock management — Ozon
  {
    name: "Ozon: Загрузка резервов FBS",
    description:
      "Загружает заказы со статусом awaiting_packaging из Ozon FBS и обновляет поле reserved_in_ozon.",
    schedule: "Каждые 2 минуты",
    jobName: remnantsOzonLoadReserved,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Отправка остатков в МП",
    description:
      "Отправляет товары с need_update_stock=true в Ozon и сохраняет last_stock / last_update.",
    schedule: "Каждую минуту",
    jobName: remnantsOzonSendRemnants,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Загрузка остатков со склада МП",
    description:
      "Загружает фактические остатки со склада Ozon (present, free_stock, reserved) и сохраняет в mp_present / mp_warehouse_sync_at.",
    schedule: "Каждые 2 минуты",
    jobName: remnantsOzonLoadWarehouseStocks,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Отправка цен",
    description:
      "Отправляет товары с need_update_price=true в Ozon и снимает флаг у успешно отправленных.",
    schedule: "Каждую минуту",
    jobName: ozonJobSendPrices,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Ozon: Загрузка продаж",
    description: "Загружает продажи Ozon за последние 2 дня.",
    schedule: "1-я и 31-я минута каждого часа",
    jobName: ozonJobLoadSales,
    jobData: { marketplace: "ozon" },
  },
  // Yandex Market
  {
    name: "YA: Отправка цен",
    description: "Отправляет товары с need_update_price=true в Яндекс Маркет.",
    schedule: "Каждую минуту",
    jobName: yaJobSendPrices,
  },
  {
    name: "YA: Отправка остатков",
    description: "Отправляет товары с need_update_stock=true в Яндекс Маркет.",
    schedule: "Каждые 2 минуты",
    jobName: yaJobSendRemnants,
  },
  {
    name: "YA: Загрузка резервов",
    description:
      "Загружает PROCESSING/STARTED заказы из Яндекс Маркета и обновляет reserved_in_ya.",
    schedule: "Каждые 5 минут",
    jobName: yaJobLoadReserved,
  },
  {
    name: "YA: Загрузка продаж",
    description: "Загружает продажи Яндекс Маркет за последние 2 дня.",
    schedule: "03:05 и 18:05 UTC",
    jobName: yaJobLoadSales,
  },
  {
    name: "YA/Sber: Обновление токенов",
    description: "Обновляет SK в Яндекс и session id для Сбера.",
    schedule: "Ежедневно 03:00 UTC",
    jobName: yaJobUpdateSk,
  },
  {
    name: "Sber: Отправка цен",
    description: "Отправляет цены в Сбер.",
    schedule: "Каждую минуту",
    jobName: sberJobSendPrices,
  },
  {
    name: "Sber: Отправка остатков",
    description: "Отправляет остатки в Сбер.",
    schedule: "Каждые 2 минуты",
    jobName: sberJobSendRemnants,
  },
  {
    name: "Sber: Загрузка резервов",
    description: "Синхронизирует reserved_in_sber.",
    schedule: "Каждые 5 минут",
    jobName: sberJobLoadReserved,
  },
  {
    name: "Ali: Отправка цен",
    description: "Отправляет цены в AliExpress.",
    schedule: "Каждую минуту",
    jobName: aliJobSendPrices,
  },
  {
    name: "Ali: Отправка остатков",
    description: "Отправляет остатки в AliExpress.",
    schedule: "Каждые 2 минуты",
    jobName: aliJobSendRemnants,
  },
  {
    name: "Ali: Загрузка резервов",
    description: "Синхронизирует reserved_in_ali.",
    schedule: "Каждые 4 минуты",
    jobName: aliJobLoadReserved,
  },
  {
    name: "Ali: Обновление product_code",
    description: "Обновляет product_id в ali_data по списку SKU.",
    schedule: "Каждый час на 15-й минуте",
    jobName: aliJobUpdateProductCode,
  },
  // Product questions
  {
    name: "WB: Загрузка вопросов",
    description: "Загружает вопросы покупателей с Wildberries.",
    schedule: "Каждые 5 минут",
    jobName: productQuestionsJobLoad,
    jobData: { marketplace: "wildberries" },
  },
  {
    name: "Ozon: Загрузка вопросов",
    description: "Загружает вопросы покупателей с Ozon.",
    schedule: "Каждые 5 минут",
    jobName: productQuestionsJobLoad,
    jobData: { marketplace: "ozon" },
  },
  {
    name: "Вопросы: Отправка ответов",
    description: "Отправляет подтверждённые ответы на вопросы.",
    schedule: "Каждые 2 минуты",
    jobName: productQuestionsJobSend,
  },
  {
    name: "Охота слотов WB: watchdog",
    description: "Проверяет heartbeat охоты и поднимает loop, если он остановился.",
    schedule: "Каждую минуту",
    jobName: wbSlotsEnsure,
  },
];
